import React, { useState, useEffect } from 'react';
import Loading from '../../Common/Loading';
import CustomAlert from '../../Common/CustomAlert';
import add_n from '../../Common/Images/add_n.gif';
import add_o from '../../Common/Images/add_o.gif';
import save_n from '../../Common/Images/save_n.gif';
import save_o from '../../Common/Images/save_o.gif'; 
import close_n from '../../Common/Images/close_n.gif';
import close_o from '../../Common/Images/close_o.gif';

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

interface CountryType {
    Major: string;
    minor?: string;
}

interface StateDetail {
    State: string;
    TimeDifference: string;
}

const EL_ManageStates: React.FC = () => {
    const [countries, setCountries] = useState<CountryType[]>([]);
    const [statesList, setStatesList] = useState<StateDetail[]>([]);
    
    const [selectedCountry, setSelectedCountry] = useState<string>('');
    const [selectedState, setSelectedState] = useState<string>('');
    const [timeDiff, setTimeDiff] = useState<string>('');

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [alertInfo, setAlertInfo] = useState({ show: false, message: '', isSuccess: false });

    const [isAddHovered, setIsAddHovered] = useState(false);
    const [isSaveHovered, setIsSaveHovered] = useState(false);
    const [isCloseHovered, setIsCloseHovered] = useState(false);

    useEffect(() => {
    const fetchCountries = async () => {
    try {
        const res = await fetch(`${API_BASE_URL}api/get_countries/`);
        const data = await res.json();

        if (Array.isArray(data?.countries)) {
            const formatted = data.countries.map((c: string) => ({ Major: c }));
            setCountries(formatted);
        }

    } catch (err) {
        console.error("Failed to load countries", err);
    }
};
        fetchCountries();
    }, []);

    useEffect(() => {
        if (!selectedCountry) {
            setStatesList([]);
            setSelectedState('');
            setTimeDiff('');
            return;
        }

        const fetchStates = async () => {
            setIsLoading(true);
            try {
                const res = await fetch(`${API_BASE_URL}api/manage_states/get_states/?country=${encodeURIComponent(selectedCountry)}`);
                const data = await res.json();
                if (data.status === 'success') {
                    setStatesList(data.states);
                    setSelectedState('');
                    setTimeDiff('');
                }
            } catch (err) {
                console.error("Failed to load states", err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchStates();
    }, [selectedCountry]);

    useEffect(() => {
        if (selectedState) {
            const stateObj = statesList.find(s => s.State === selectedState);
            if (stateObj) {
                const diff = stateObj.TimeDifference;
                setTimeDiff(diff != null ? String(diff) : '');
            }
        } else {
            setTimeDiff('');
        }
    }, [selectedState, statesList]);

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            if (event.data === 'stateAdded') {
                if (selectedCountry) {
                    const temp = selectedCountry;
                    setSelectedCountry('');
                    setTimeout(() => setSelectedCountry(temp), 50);
                }
            }
        };  

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, [selectedCountry]);

    const handleSave = async () => {
        if (!selectedCountry || !selectedState) {
            setAlertInfo({ show: true, message: "Country and State should be Selected for Saving.", isSuccess: false });
            return;
        }

        setIsLoading(true);
        try {
            const response = await fetch(`${API_BASE_URL}api/manage_states/update/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    state: selectedState,
                    timeDiff: timeDiff
                })
            });

            const result = await response.json();
            if (result.status === 'success') {
                setAlertInfo({ show: true, message: "Data Saved Successfully.", isSuccess: true });
                
                setStatesList(prev => prev.map(s => 
                    s.State === selectedState ? { ...s, TimeDifference: timeDiff } : s
                ));
            } else {
                setAlertInfo({ show: true, message: result.message, isSuccess: false });
            }
        } catch (error) {
            console.error("Save failed", error);
            setAlertInfo({ show: true, message: "Failed to save due to network error.", isSuccess: false });
        } finally {
            setIsLoading(false);
        }
    };

    const handleAddState = () => {
        const url = `/WebAdmin/Admin/EL_AddEditStates?State=${encodeURIComponent(selectedState || '')}&Mode=ADD`;
        window.open(url, "", "top=500,left=500,width=500,height=300");
    };

    const handleTimeDiffChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        if (/^-?\d*\.?\d*$/.test(val)) {
            setTimeDiff(val);
        }
    };

    const handleCloseAlert = () => {
        setAlertInfo({ show: false, message: '', isSuccess: false });
    };

    return (
        <div style={{ margin: 0, backgroundColor: 'white', fontFamily: 'Arial', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            {isLoading && <Loading />}

            <div style={{ textAlign: 'center', fontFamily: 'Arial', margin: '2px 6px' }}>
                <table style={{ width: '100%', fontFamily: 'Arial' }} cellPadding={0} cellSpacing={0}>
                    <tbody>
                        <tr>
                            <td>&nbsp;</td>
                            <td style={{ border: '1px solid #0000FF', textAlign: 'center', width: '100%', backgroundColor: '#B5DCED', color: '#0000FF', fontFamily: 'Arial', padding: '1px' }}>
                                <b>MANAGING STATES</b>
                            </td>
                            <td style={{ width: '2%' }}>&nbsp;</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div style={{ padding: '10px', textAlign: 'center', fontFamily: 'Arial', fontSize: '13px' }}>
                <table style={{ width: '100%', fontFamily: 'Arial' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '2%' }}>&nbsp;</td>
                            <td align="right" style={{ textAlign: 'right', width: '48%', fontSize: '16px'}}>
                                Country:
                            </td>
                            <td style={{ textAlign: 'left', width: '48%', padding: '10px' }}>
                                <select
                                    value={selectedCountry}
                                    onChange={(e) => setSelectedCountry(e.target.value)}
                                    style={{ width: '200px' }}
                                >
                                    <option value="">-- Select --</option>
                                    {countries.map((c, idx) => (
                                        <option key={idx} value={c.Major}>{c.Major}</option>
                                    ))}
                                </select>
                            </td>
                            <td style={{ width: '2%' }}>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td align="right" style={{ fontSize: '16px' }}>
                                State:
                            </td>
                            <td style={{ textAlign: 'left', padding: '10px' }}>
                                <select
                                    value={selectedState}
                                    onChange={(e) => setSelectedState(e.target.value)}
                                    style={{ width: '200px' }}
                                >
                                    <option value="">-- Select --</option>
                                    {statesList.map((s, idx) => (
                                        <option key={idx} value={s.State}>{s.State}</option>
                                    ))}
                                </select>
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td align="right" style={{ fontSize: '16px' }}>
                                Time Difference with UTC (Hrs):
                            </td>
                            <td style={{ textAlign: 'left', padding: '10px' }}>
                                <input
                                    type="text"
                                    value={timeDiff}
                                    onChange={handleTimeDiffChange}
                                    maxLength={5}
                                    style={{ width: '150px', border: '1px solid #003300' }} 
                                />
                            </td>
                            <td>&nbsp;</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div style={{ padding: '10px' }}>
                <table style={{ width: '100%', fontFamily: 'Arial' }}>
                    <tbody>
                        <tr>
                            <td style={{ textAlign: 'center' }}>
                                <img
                                    src={isAddHovered ? add_o : add_n}
                                    alt="Add"
                                    title="Add New State"
                                    onClick={handleAddState}
                                    onMouseEnter={() => setIsAddHovered(true)}
                                    onMouseLeave={() => setIsAddHovered(false)}
                                    style={{ cursor: 'pointer', verticalAlign: 'middle', marginRight: '23px' }}
                                />
                                <img 
                                    src={isSaveHovered ? save_o : save_n}
                                    alt="Save"
                                    title="Save Time Difference"
                                    onClick={handleSave}
                                    onMouseEnter={() => setIsSaveHovered(true)}
                                    onMouseLeave={() => setIsSaveHovered(false)}
                                    style={{ cursor: 'pointer', verticalAlign: 'middle', marginRight: '22px' }}
                                />
                                <img 
                                    src={isCloseHovered ? close_o : close_n}
                                    alt="Close"
                                    title="Close Window"
                                    onClick={() => window.close()}
                                    onMouseEnter={() => setIsCloseHovered(true)}
                                    onMouseLeave={() => setIsCloseHovered(false)}
                                    style={{ cursor: 'pointer', verticalAlign: 'middle' }}
                                />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            {alertInfo.show && (
                <CustomAlert
                    message={alertInfo.message}
                    onClose={handleCloseAlert}
                />
            )}
        </div>
    );
};

export default EL_ManageStates;